module.exports = __webpack_public_path__ + "img/users-duotone.43a2324b.svg";